import React from "react";
import ContactList from "../../../_components/Contacts/ContactList";
import {
    getSuppliers, getSupplierKpis, deleteSupplier,
    AREAS, STATUSES, SEARCH_TYPES,
} from "../../../_services/contact.service";

export default function Suppliers() {
    return (
        <ContactList
            title="Supplier List"
            type="Supplier"
            fetchList={getSuppliers}
            fetchKpis={getSupplierKpis}
            deleteItem={deleteSupplier}
            AREAS={AREAS}
            STATUSES={STATUSES}
            SEARCH_TYPES={SEARCH_TYPES}
        />
    );
}